import styled from 'styled-components'
import { UITypes } from 'LibNeo'

const textColor = {
	[UITypes.DANGER]: '#a94442',
	[UITypes.SUCCESS]: '#3c763d',
	[UITypes.WARNING]: '#8a6d3b',
	[UITypes.INFO]: '#31708f',
}

const backgroundColor = {
	[UITypes.DANGER]: '#f2dede',
	[UITypes.SUCCESS]: '#dff0d8',
	[UITypes.WARNING]: '#fcf8e3',
	[UITypes.INFO]: '#d9edf7',
}

export const NotifyWrapper = styled.div<{ kind: keyof typeof textColor }>`
	padding: 15px;
	margin-bottom: 20px;
	color: ${({ kind }) => textColor[kind]};
	background-color: ${({ kind }) => backgroundColor[kind]};
	border-radius: 4px;
	text-align: center;
`
